// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3XWLk","col":"styles_col__11dYc"};